import { CREATE_BG_PRODUCT_FAIL, CREATE_BG_PRODUCT_REQUEST, CREATE_BG_PRODUCT_SUCCESS, DELETE_BG_PRODUCT_FAIL, DELETE_BG_PRODUCT_REQUEST, DELETE_BG_PRODUCT_SUCCESS, FETCH_BG_PRODUCT_FAIL, FETCH_BG_PRODUCT_REQUEST, FETCH_BG_PRODUCT_SUCCESS, SHOW_BG_PRODUCT_FAIL, SHOW_BG_PRODUCT_REQUEST, SHOW_BG_PRODUCT_SUCCESS, UPDATE_BG_PRODUCT_FAIL, UPDATE_BG_PRODUCT_REQUEST, UPDATE_BG_PRODUCT_SUCCESS } from "../ActionType/ProductType/bgProductType";


  
  export const getBgProductReducer = (
      state = { loading: true, bgProduct: [],total:0, error: "" },
      action
    ) => {
      switch (action.type) {
        case FETCH_BG_PRODUCT_REQUEST:
          return {
            loading: true,
          };
        case FETCH_BG_PRODUCT_SUCCESS:
          console.log(action.payload)
          return {
            loading: false,
            bgProduct: action.payload,
            // total:action.total,
            error: "",
          };
        case FETCH_BG_PRODUCT_FAIL:
          return {
            loading: false,
            bgProduct: [],
            error: "",
          };
        default:
          return state;
      }
    };
  
    
  export const createBgProductReducer = (
    state = { loading: true, data: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case CREATE_BG_PRODUCT_REQUEST:
        return {
          loading: true,
        };
      case CREATE_BG_PRODUCT_SUCCESS:
        return {
          loading: false,
          data: action.payload,
          error: "",
        };
      case CREATE_BG_PRODUCT_FAIL:
        return {
          loading: false,
          data: [],
          error: "",
        };
      default:
        return state;
    }
  };
  
  export const deleteBgProductReducer = (
    state = { loading: true, data: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case DELETE_BG_PRODUCT_REQUEST:
        return {
          loading: true,
        };
      case DELETE_BG_PRODUCT_SUCCESS:
        return {
          loading: false,
          data: action.payload,
          error: "",
        };
      case DELETE_BG_PRODUCT_FAIL:

        return {
          loading: false,
          data: [],
          error: "",
        };
      default:
        return state;
    }
  };
  
  
  export const showBgProductReducer = (
    state = { loading: true, datas: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case SHOW_BG_PRODUCT_REQUEST:
        return {
          loading: true,
        };
      case SHOW_BG_PRODUCT_SUCCESS:
        return {
          loading: false,
          datas: action.payload,
          error: "",
        };
      case SHOW_BG_PRODUCT_FAIL:
        return {
          loading: false,
          datas: [],
          error: "",
        };
      default:
        return state;
    }
  };
  
  export const updateProductReduer = (
    state = { loading: true, data: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case UPDATE_BG_PRODUCT_REQUEST:
        return {
          loading: true,
        };
      case UPDATE_BG_PRODUCT_SUCCESS:
        return {
          loading: false,
          data: action.payload,
          error: "",
        };
      case UPDATE_BG_PRODUCT_FAIL:
        return {
          loading: false,
          data: [],
          error: "Please CHeck your Query",
        };
      default:
        return state;
    }
  };